/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from "react";
import { PageLink, PageTitle } from "../../components/layout/core";

const myselfBreadCrumbs: Array<PageLink> = [
  {
    title: "O’zining ishi bo’yicha talablarni tekshirish",
    path: "/",
    isSeparator: false,
    isActive: false,
  },
];

const CheckMyself: FC = () => {
  return (
    <>
      <PageTitle
        description="Metodik ishlanma va savollar"
        breadcrumbs={myselfBreadCrumbs}
      />
    </>
  );
};

export { CheckMyself };
